import { useContext, useEffect } from 'react';

import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

import { CameraSetup } from '@data';

import { MediaSizeContext } from '../components/context';

import { toMatrix4, getCoverAdjustedIntrinsics } from './utils';

export function CameraFromCalibration({ config }: { config: CameraSetup }) {
    const { camera } = useThree();
    const size = useContext(MediaSizeContext);

    useEffect(() => {
        camera.manual = true;
        camera.matrixAutoUpdate = false;

        const world = toMatrix4(config.cameraInWorld).multiply(new THREE.Matrix4().makeScale(1, -1, -1));

        camera.matrix.copy(world);
        camera.matrixWorld.copy(world);
        camera.matrixWorldInverse.copy(world).invert();

        const W = size.width;
        const H = size.height;
        const { fx, fy, cx, cy } = getCoverAdjustedIntrinsics(config, W, H);
        const near = 0.01,
            far = 1000;

        camera.projectionMatrix.set(
            (2 * fx) / W,
            0,
            1 - (2 * cx) / W,
            0,
            0,
            (2 * fy) / H,
            (2 * cy) / H - 1,
            0,
            0,
            0,
            -(far + near) / (far - near),
            -(2 * far * near) / (far - near),
            0,
            0,
            -1,
            0,
        );
        camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
    }, [camera, config, size.height, size.width]);

    return null;
}
